import { BODY_META, type BodyType } from '@/lib/types';
import { Icon, type IconName } from '@/components/Icon';
import './BodyBadge.css';

/**
 * Body-type badge: a colored pill with an icon, never just a label (README § Product concept).
 *
 * The set is built for four types and extends without a redesign — County and State already
 * have their colors and render as "coming soon" in pickers.
 */

const BODY_ICON: Record<BodyType, IconName> = {
  municipal: 'landmark',
  boe: 'cap',
  county: 'map',
  state: 'gavel',
};

export function BodyBadge({ body, short = false }: { body: BodyType; short?: boolean }) {
  const meta = BODY_META[body];
  return (
    <span className="bodyBadge" data-body={body}>
      <Icon name={BODY_ICON[body]} />
      {short ? meta.short : meta.label}
    </span>
  );
}
